import React from 'react';
import AppTheme from '../Enums/AppTheme';

export type SettingsContextProps = {
    theme: AppTheme,
    setTheme: (theme: AppTheme) => void,
};

const SettingsContext: React.Context<SettingsContextProps> = React.createContext<SettingsContextProps>({
    theme: AppTheme.LIGHT_MODE,
    setTheme: () => {},
});

export default SettingsContext;